export default "__VITE_ASSET__BAlF2v5J__"